import {css} from '@emotion/css';
import {VosLogoLaptop} from 'Shared/backend/icons/VosLogoLaptop';

/* The laptop mark is around 2:1, so it is sized on width and lets its height follow. */
const laptopStyle = () => css({
	display: 'block',
	width: '14em',
	maxWidth: '100%',
	margin: '0 auto'
});

export function LoginBanner()
{
	return (
		<header>
			<div class='headerOntoit'>
				<VosLogoLaptop class={laptopStyle()} />
			</div>
		</header>
	);
}
